import script from "./VModalNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./VModalNotification.vue?vue&type=script&setup=true&lang=ts"

import "./VModalNotification.vue?vue&type=style&index=0&id=0598ebde&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0598ebde"]])

export default __exports__